// import { useState } from "react";
import { Animated } from "react-animated-css";
import { useSelector } from "react-redux";
// import socket from "../../assets/socketConnection";
import { selectUserIsConnected } from "../../redux/user/user.selectors";
import { SocketConnectionStatusStyled } from "./SocketConnectionStatus.styles";

const SocketConnectionStatus = () => {
  //   const [isDisconnected, setIsDisconnected] = useState(false);

  const isConnected = useSelector(selectUserIsConnected);

  return (
    <>
      <SocketConnectionStatusStyled>
        <Animated
          animationIn="bounceIn"
          animationOut="bounceOutDown"
          animationInDuration={500}
          animationOutDuration={500}
          isVisible={!isConnected}
          className="animated position-relative"
        >
          <div className="inner text-center shadow bg-warning p-md-1">
            ارتباط شما با سرور برقرار نیست!
          </div>
        </Animated>
      </SocketConnectionStatusStyled>
    </>
  );
};

export default SocketConnectionStatus;
